export const PANEL_MIN_WIDTH = 391;
export const PANEL_MAX_WIDTH = 1200;
